import { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminDashboardVideoCategories() {
  const [categories, setCategories] = useState([]);
  const [name, setName] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/api/video-categories');
        setCategories(data);
      } catch {
        console.error('Error fetching video categories');
      }
    })();
  }, []);

  async function addCategory(e) {
    e.preventDefault();
    if (!name.trim()) return;
    const { data } = await axios.post('/api/video-categories', { name });
    setCategories(prev => [...prev, data]);
    setName('');
  }

  async function deleteCategory(id) {
    await axios.delete(`/api/video-categories/${id}`);
    setCategories(prev => prev.filter(c => c._id !== id));
  }

  return (
    <div className="container py-5">
      <h1 className="h4 mb-4">Manage Video Categories</h1>

      {/* فرم افزودن دسته‌بندی */}
      <form onSubmit={addCategory} className="mb-4">
        <input
          className="form-control mb-2"
          placeholder="Category name"
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <button className="btn btn-success">Add Category</button>
      </form>

      {/* لیست دسته‌بندی‌ها */}
      <ul className="list-group">
        {categories.map(c => (
          <li key={c._id} className="list-group-item d-flex justify-content-between align-items-center">
            {c.name}
            <button
              className="btn btn-sm btn-danger"
              onClick={() => deleteCategory(c._id)}
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
